export const UPDATE_STAFF = `staff/update_staff`;
export const SET_LOADING = `staff/set_loading`;
export const SET_STAFF = `staff/set_staff`;

export const REMOVE_AUTH = `staff/remove_auth`;
export const CREATE_AUTH = `staff/create_auth`;



// WEBPACK FOOTER //
// ./src/store/base/staff/types.js